// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter Tight", sans-serif;
}

html {
  --app-font-scale: 1;
  font-size: calc(10px * var(--app-font-scale));
  interpolate-size: allow-keywords;
}

html[data-font-size=sm] {
  --app-font-scale: 0.8;
}

html[data-font-size=md] {
  --app-font-scale: 1;
}

html[data-font-size=lg] {
  --app-font-scale: 1.2;
}

body {
  font-size: 1.6rem;
  font-family: "Montserrat", sans-serif;
}
.theme--light body {
  background-color: #ffffff;
}
.theme--dark body {
  background-color: #1c1c1c;
}

body::-webkit-scrollbar {
  height: 0;
  width: 0;
}

button,
input,
select,
textarea {
  font: inherit;
}

img {
  max-width: 100%;
}

.global-module_mapboxgl-ctrl-logo___s9mMP {
  display: none !important;
}

::selection {
  color: white;
  background-color: var(--textDetails);
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.theme--light ::-webkit-scrollbar-track {
  background: #ffffff;
}
.theme--dark ::-webkit-scrollbar-track {
  background: #1c1c1c;
}

::-webkit-scrollbar-thumb {
  border-radius: 12px;
}
.theme--light ::-webkit-scrollbar-thumb {
  background: #888888;
}
.theme--dark ::-webkit-scrollbar-thumb {
  background: #a3a3a3;
}

::-webkit-scrollbar-thumb:hover {
  cursor: pointer;
}
.theme--light ::-webkit-scrollbar-thumb:hover {
  background: rgb(from #888888 calc(r - 20) calc(g - 20) calc(b - 20));
}
.theme--dark ::-webkit-scrollbar-thumb:hover {
  background: rgb(from #a3a3a3 calc(r - 20) calc(g - 20) calc(b - 20));
}

*::-webkit-scrollbar-corner {
  background: transparent;
}

ol[data-sonner-toaster=true] li {
  padding: 16px;
}

@media only screen and (max-width: breakPointLpx) {
  html {
    font-size: calc(9.5px * var(--app-font-scale));
  }
}
@media only screen and (max-width: breakPointMpx) {
  html {
    font-size: calc(9px * var(--app-font-scale));
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/global.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,SAAA;EACA,UAAA;EACA,sBAAA;EACA,sCAAA;AAmBD;;AAhBA;EACC,mBAAA;EAEA,6CAAA;EACA,gCAAA;AAkBD;;AAfA;EACC,qBAAA;AAkBD;;AAfA;EACC,mBAAA;AAkBD;;AAfA;EACC,qBAAA;AAkBD;;AAfA;EACC,iBAAA;EACA,qCAAA;AAkBD;ADwDE;ECvEA,yBAAA;AAkBF;ADqDE;ECvEA,yBAAA;AAqBF;;AAjBA;EACC,SAAA;EACA,QAAA;AAoBD;;AAjBA;;;;EAIC,aAAA;AAoBD;;AAjBA;EACC,eAAA;AAoBD;;AAjBA;EACC,wBAAA;AAoBD;;AAjBA;EACC,YAAA;EACA,oCAAA;AAoBD;;AAjBA;EACC,UAAA;EACA,WAAA;AAoBD;;ADoBE;ECnCA,mBAAA;AAmBF;ADgBE;ECnCA,mBAAA;AAsBF;;AAlBA;EACC,mBAAA;AAqBD;ADSE;EC3BA,mBAAA;AAqBF;ADME;EC3BA,mBAAA;AAwBF;;AApBA;EACC,eAAA;AAuBD;ADDE;ECpBA,oEAAA;AAwBF;ADJE;ECpBA,oEAAA;AA2BF;;AAvBA;EACC,uBAAA;AA0BD;;AAvBA;EACC,aAAA;AA0BD;;AAvBA;EACC;IACC,8CAAA;EA0BA;AACF;AAvBA;EACC;IACC,4CAAA;EAyBA;AACF","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: \"Inter Tight\", sans-serif;\n}\n\nhtml {\n  --app-font-scale: 1;\n  font-size: calc(10px * var(--app-font-scale));\n  interpolate-size: allow-keywords;\n}\n\nhtml[data-font-size=sm] {\n  --app-font-scale: 0.8;\n}\n\nhtml[data-font-size=md] {\n  --app-font-scale: 1;\n}\n\nhtml[data-font-size=lg] {\n  --app-font-scale: 1.2;\n}\n\nbody {\n  font-size: 1.6rem;\n  font-family: \"Montserrat\", sans-serif;\n}\n:global(.theme--light) body {\n  background-color: #ffffff;\n}\n:global(.theme--dark) body {\n  background-color: #1c1c1c;\n}\n\nbody::-webkit-scrollbar {\n  height: 0;\n  width: 0;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  font: inherit;\n}\n\nimg {\n  max-width: 100%;\n}\n\n.mapboxgl-ctrl-logo {\n  display: none !important;\n}\n\n::selection {\n  color: white;\n  background-color: var(--textDetails);\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n:global(.theme--light) ::-webkit-scrollbar-track {\n  background: #ffffff;\n}\n:global(.theme--dark) ::-webkit-scrollbar-track {\n  background: #1c1c1c;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 12px;\n}\n:global(.theme--light) ::-webkit-scrollbar-thumb {\n  background: #888888;\n}\n:global(.theme--dark) ::-webkit-scrollbar-thumb {\n  background: #a3a3a3;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  cursor: pointer;\n}\n:global(.theme--light) ::-webkit-scrollbar-thumb:hover {\n  background: rgb(from #888888 calc(r - 20) calc(g - 20) calc(b - 20));\n}\n:global(.theme--dark) ::-webkit-scrollbar-thumb:hover {\n  background: rgb(from #a3a3a3 calc(r - 20) calc(g - 20) calc(b - 20));\n}\n\n*::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\nol[data-sonner-toaster=true] li {\n  padding: 16px;\n}\n\n@media only screen and (max-width: breakPointLpx) {\n  html {\n    font-size: calc(9.5px * var(--app-font-scale));\n  }\n}\n@media only screen and (max-width: breakPointMpx) {\n  html {\n    font-size: calc(9px * var(--app-font-scale));\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapboxgl-ctrl-logo": `global-module_mapboxgl-ctrl-logo___s9mMP`
};
export default ___CSS_LOADER_EXPORT___;
